module.exports = __webpack_public_path__ + "img/visa.96f4cd68.svg";